import HospitalUserDTO from '@src/adapters/dto/hospital/HospitalUserDTO';
import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  hospitalId: string;
  status: string;
  pageSize: number;
  currentPage: number;
  searchText: string;
  role: string;
}

interface Result {
  records: HospitalUserDTO[];
  recordCount: number;
}
const options: ApiOptions = {
  method: 'get',
  urlPath: '/hospital/users',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useSearchHospitalUsersLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useSearchHospitalUsersLazy;
